import React, {useEffect, useState} from 'react'
import {LargeIconStyle} from "../styles";
import {Overlay} from "./overlay";
import {useSelector} from "react-redux"
import useTranslation from "../../virtual_congress/effects/use_translation";

const Countdown = ({finished}) => {
  const translation = useTranslation()

  const countdownTime = useSelector(state => state.countdown_time)

  const countdownTextStyle = {
    ...LargeIconStyle,
    opacity: 0,
    animationName: "countdownAnimation",
    animationDuration: "1s",
  }

  const countdownTextBigStyle = {
    ...LargeIconStyle,
    fontSize: "9rem",
    animation: "shake 0.15s infinite",
  }

  const colors = ["#ff0044", "#ff00dd", "#3500ff", "#00ffc6", "#19ff00", "#fff900", "#ff5500"]
  const color = colors[Math.floor(Math.random() * colors.length)];

  const [currentTime, setCurrentTime] = useState(countdownTime || 3)
  const [textStyle, setTextStyle] = useState({...countdownTextStyle, color})

  useEffect(() => {
    let countdownInterval = null

    countdownInterval = setInterval(() => {
      const color = colors[Math.floor(Math.random() * colors.length)];

      setCurrentTime(currentTime => {
        const nextTime = currentTime - 1
        // if (nextTime === 0) {
        //   setTextStyle({...countdownTextBigStyle, color})
        if (nextTime <= 0) {
          clearInterval(countdownInterval)
          if (finished) {
            finished()
          }
        } else {
          setTextStyle({...countdownTextStyle, color})
        }
        return nextTime
      })
    }, 1000)

    return () => {
      clearInterval(countdownInterval)
    }
  }, [])

  const countdownText = currentTime > 0 ? currentTime.toString() : translation("selfie_upload.countdown_go", {}, "GO!")

  return <>
    <style>
      {`
        @keyframes countdownAnimation {
          from {
            opacity: 1;
            transform: scale(1);
          }
          to {
            opacity: 0;
            transform: scale(2);
          }
        }
        @keyframes shake {
          0% {
            transform: rotate(0deg);
          }
          25% {
            transform: rotate(10deg);
          }
          50% {
            transform: rotate(0deg);
          }
          70% {
            transform: rotate(-10deg);
          }
          100% {
            transform: rotate(0deg);
          }
        }
      `}
    </style>
    <Overlay>
      <div key={currentTime} style={textStyle}>
        {countdownText}
      </div>
    </Overlay>
  </>
}

export default Countdown